import React, { useEffect, useState } from "react";
import GlobeIcon from "../../../../../assets/svg/globeIcon.svg";
import PollIcon from "../../../../../assets/svg/pollIcon.svg";
import ArticleIcon from "../../../../../assets/svg/articleIcon.svg";
import MediaIcon from "../../../../../assets/svg/mediaIcon.svg";
import LikesIcon from "../../../../../assets/svg/likesIcon.svg";
import LikedIcon from "../../../../../assets/svg/likedIcon.svg";
import DislikeIcon from "../../../../../assets/svg/disLikeIcon.svg";
import DislikedIcon from "../../../../../assets/svg/disLikedIcon.svg";
import CommentIcon from "../../../../../assets/svg/commentIcon.svg";
import DeleteIcon from "../../../../../assets/svg/deleteCohort.svg";
import EditButton from "../../../../../assets/svg/editButton.svg";
// import profileIcon from "../../../../../assets/svg/dashboard/profile-iconRound.svg";
import profileIcon from "../../../../../assets/images/hashImage.jpeg";
import CommentIconPressed from "../../../../../assets/svg/commentIconPressed.svg";
import Select from "react-select";
import { Poll } from "@material-ui/icons";
import CreateThread from "../../../../common/createThread";
import CreatePoll from "../../../../common/createPoll";
import { connect } from "react-redux";
import { withRouter,useParams } from "react-router-dom";
import CommentsBox from "../../../../common/commentsBox";
import cloneDeep from "lodash/cloneDeep";
import swal from "sweetalert";
import {
  cohortDiscussionList,
  cohortDiscussionCommentsList,
  cohortDiscussionAddComment,
  cohortDiscussionPostLikeToggle,
  cohortCommentPostLikeToggle,
  cohortCommentPostRemoveLike,
  cohortDiscussionPostRemoveLike,
  cohortThreadRemovePost,
  postCohortDiscussionActivity,
} from "../dependencies/action";
import * as CryptoJS from "crypto-js";
import moment from "moment";
import Parser from "html-react-parser";
import { PROFILE_KEY } from "../../../../common/constants/actionConstants";
import ProgressBar from "../../../../common/progressBar";
import Button from "../../AdminDashboard/Button";
function DiscussionPage(props) {
  const loggedIn = JSON.parse(localStorage.getItem("SavedLoggedInData"));
  const {
    cohortDiscussionList,
    cohortDiscussionPostLikeToggle,
    cohortCommentPostLikeToggle,
    cohortDiscussionAddComment,
    cohortDiscussionCommentsList,
    discussionList,
    discussionListPaginate,
    cohortCommentPostRemoveLike,
    cohortDiscussionPostRemoveLike,
    cohortThreadRemovePost,
    postCohortDiscussionActivity,
    cohortActivityData,
    setDiscussionFlag,
  } = props;
  const [openThread, setOpenThread] = useState(false);
  const [openPoll, setOpenPoll] = useState(false);
  const [reloadPage, setReloadPage] = useState(false);
  const [threadMode, setThreadMode] = useState("");
  const [pollMode, setPollMode] = useState("");
  const [threadData, setThreadData] = useState("");
  const [threadIndex, setThreadIndex] = useState(-1);
  const [commentsData, setCommentsData] = useState("");
  const [listPage, setListPage] = useState(1);
  const [commentsVisibility, setCommentsVisibility] = useState(false);
  const [discussionList2, setDiscussionList2] = useState();
  const [toggleMsg, setToggleMsg] = useState(false);
  const [threadSort, setThreadSort] = useState("");
  const [completed, setCompleted] = useState(0);
  const [progressView, setProgressView] = useState(false);
  const [pollSelect, setPollSelect] = useState(0);
  const [pollErr, setPollErr] = useState(false);
  const urlParams = useParams();
  useEffect(() => {
    setInterval(() => setCompleted(Math.floor(Math.random() * 100) + 1), 2000);
  }, []);
  const customStyles = {
    indicatorSeparator: (styles) => ({ display: "none" }),
    placeholder: (defaultStyles) => {
      return {
        ...defaultStyles,
        fontSize: "14px",
        fontFamily: "Montserrat",
      };
    },
    control: (styles) => ({
      ...styles,
      backgroundColor: "white",
      minWidth: "9.75rem",
      maxWidth: "10rem",
      // color: "#333",
      color: "rgb(121, 193, 206)",
      whiteSpace: "nowrap",
      fontSize: "14px",
      position: "relative",
    }),
    menu: (base) => ({
      ...base,
      width: "max-content",
      // minWidth: "100%",
      fontSize: "14px",
    }),
    option: (styles, { data, isDisabled, isFocused, isSelected }) => {
      return {
        ...styles,
        backgroundColor: isSelected
          ? "#b499c7"
          : isFocused
          ? "#e4d7ee"
          : "white",
        color: isSelected ? "white" : "black",
        cursor: isDisabled ? "not-allowed" : "default",
        whiteSpace: "nowrap",
        textAlign: "left",
      };
    },
  };
  const approvalOptions = [
    {
      value: "Recent",
      label: "Most Recent",
    },
    {
      value: "Ascending",
      label: "Ascending Order",
    },
    {
      value: "Descending",
      label: "Descending Order",
    },
  ];

  const { parentData } = props;
  const fetchList = (pageNum, status) => {
    let params = {
      cohortId:
      parentData?.cohortId != undefined &&
      parentData?.cohortId != null &&
      parentData?.cohortId != ""
        ? parentData?.cohortId
        : urlParams?.cohortId,
      pageFilter: {
        currentPage: 0,
        includeCount: true,
        pageSize: pageNum !== 0 && pageNum > 0 ? pageNum * 10 : 10,
        sortField: status == "Recent" ? "lastUpdated" : "addedDate",
        sortOrder: status == "Ascending" ? "ASC" : "DESC",
      },
    };
    cohortDiscussionList(params);
  };
  const fetchCommentsList = (postId) => {
    let params = {
      cohortId: parentData?.cohortId,
      postId: "",
      pageFilter: {
        currentPage: 0,
        includeCount: true,
        pageSize: 10,
        sortField: "lastUpdated",
        sortOrder: "DESC",
      },
    };
    cohortDiscussionCommentsList(params);
  };
  const postCommentsList = (postId, comments) => {
    let params = {
      cohortId: parentData?.cohortId,
      postId: postId,
      commentText: comments,
    };
    cohortDiscussionAddComment(params);
  };
  useEffect(() => {
    fetchList(1, "Recent");
  }, []);
  useEffect(() => {
    if (reloadPage) {
      fetchList(1, threadSort);
      setTimeout(() => {
        setReloadPage(false);
      }, 2000);
    }
  }, [reloadPage]);
  const detectHtml = (data) => {
    var isHTML = /<[a-z][\s\S]*>/i.test(data);
    if (isHTML && data !== undefined && data[0] !== undefined) {
      return true;
    } else {
      return false;
    }
  };
  class AesUtil {
    constructor(keySize, iterationCount) {
      this.keySize = keySize / 32;
      this.iterationCount = iterationCount;
    }

    generateKey = function (salt, passPhrase) {
      let key = CryptoJS.PBKDF2(passPhrase, CryptoJS.enc.Hex.parse(salt), {
        keySize: this.keySize,
        iterations: this.iterationCount,
      });
      return key;
    };

    encrypt = function (salt, iv, passPhrase, plainText) {
      let key = this.generateKey(salt, passPhrase);
      let encrypted = CryptoJS.AES.encrypt(plainText, key, {
        iv: CryptoJS.enc.Hex.parse(iv),
      });
      return encrypted.ciphertext.toString(CryptoJS.enc.Base64);
    };
  }
  const encryptAES2 = (text, key) => {
    // let iv = CryptoJS.lib.WordArray.random(128 / 8).toString(CryptoJS.enc.Hex);
    // let salt = CryptoJS.lib.WordArray.random(128 / 8).toString(
    //   CryptoJS.enc.Hex
    // );

    // let aesUtil = new AesUtil(128, 1000);
    // let ciphertext = aesUtil.encrypt(salt, iv, key, text);

    // let aesText = iv + "::" + salt + "::" + ciphertext;

    return btoa(text);
  };
  const currentRoute = window.location.href;
  let sample;
  sample = currentRoute.slice(0, currentRoute.lastIndexOf("/"));
  const viewMentorProfile = (item, id) => {
    // setSelectedRow(id);
    let reRoute = window.open(
      `/mentor-profile/${encryptAES2(item, PROFILE_KEY)}`,
      "_blank"
    );
    // let reRoute = window.open(sample + `/mentor-profile/${item}`, "_blank");
    reRoute.id = item;
  };
  const viewStartupProfile = (item, id) => {
    let reRoute = window.open(`/startup-profile/${item}`, "_blank");
    reRoute.id = item;
  };
  useEffect(() => {
    if (
      discussionList !== undefined &&
      discussionList !== null &&
      discussionList !== "" &&
      discussionList?.length > 0
    ) {
      let arr = [];
      let params;
      let innerID = "";

      if (
        discussionList2 !== undefined &&
        discussionList2 !== null &&
        discussionList2 !== "" &&
        discussionList2?.length > 0
      ) {
        let arrTest = cloneDeep(discussionList2);
        discussionList.forEach((element) => {
          params = element;
          innerID = element.postId;
          let exisitingData = arrTest.find(
            (element2) => element2?.postId == innerID
          );
          params.commentsVisibility = exisitingData?.commentsVisibility;
          arr.push(params);
        });
        setDiscussionList2(arr);
      } else {
        discussionList.forEach((element) => {
          params = element;
          params.commentsVisibility = false;
          arr.push(params);
        });
        setDiscussionList2(arr);
      }
    } else if (
      discussionList !== undefined &&
      discussionList !== null &&
      discussionList !== "" &&
      discussionList?.length == 0
    ) {
      setDiscussionList2([]);
    }
  }, [discussionList]);

  const timeDifference = (incomingTime) => {
    const dateFormat = "YYYY-MM-DD HH:mm:ss";
    var incomingFormat = moment(incomingTime).format(dateFormat);
    const now = moment.utc();
    var minutes = now.diff(incomingFormat, "minutes");
    var days = now.diff(incomingFormat, "days");
    var hours = now.diff(incomingFormat, "hours");
    var months = now.diff(incomingFormat, "months");
    var years = now.diff(incomingFormat, "years");
    let dayHolder =  days == 1 ? "1 day ago" : `${days} days ago`;
    let monthHolder =  months == 1 ? "1 month ago" : `${months} months ago`;
    let yearHolder =  years == 1 ? "1 year ago" : `${years} months ago`;
    let minsHolder =
      minutes == 1 || minutes == 0 ? "1 min ago" : `${minutes} mins ago`;
    let hoursHolder = hours == 1 ? "1 hr ago" : `${hours} hrs ago`;
    if (minutes < 60) return minsHolder;
    else if (hours < 24) return hoursHolder;
    else return years > 0 ? yearHolder : months > 0 ? monthHolder : dayHolder;
  };

  const likeTogglePost = (postId, liked) => {
    let params = {
      cohortId:
      parentData?.cohortId != undefined &&
      parentData?.cohortId != null &&
      parentData?.cohortId != ""
        ? parentData?.cohortId
        : urlParams?.cohortId,
      postId: postId,
      like: liked, // true for like and false for dislike
    };
    cohortDiscussionPostLikeToggle(params);
    setTimeout(() => {
      window.scrollTo(1500, 1500);
      setReloadPage(true);
    }, 1000);
  };
  const disLikeTogglePost = (postId) => {
    let params = {
      cohortId: parentData?.cohortId,
      postId: postId,
    };
    cohortDiscussionPostRemoveLike(params);
    setTimeout(() => {
      window.scrollTo(1500, 1500);
      setReloadPage(true);
    }, 1000);
  };
  const handleDelete = (postId) => {
    swal("Are you sure?", "Do you want to delete this thread?", {
      icon: "warning",
      buttons: {
        delete: {
          text: "OK",
        },
        decline: {
          text: "CANCEL",
        },
      },
    })
      .then((value) => {
        if (value === "delete") {
          deleteapiCall(postId);
        } else {
          swal("Delete operation cancelled");
        }
      })

      .catch((err) => {});
  };

  const deleteapiCall = (postId) => {
    cohortThreadRemovePost({ postId: postId });
    setTimeout(() => {
      setReloadPage(true);
    }, 1000);
  };
  useEffect(() => {
    if (listPage > 1) {
      fetchList(listPage, threadSort);
    }
  }, [listPage]);
  const testData = [
    { bgcolor: "#7FAF6A", completed: 70 },
    { bgcolor: "#e34262", completed: 20 },
    { bgcolor: "#ffb366", completed: 10 },
  ];
  const testData2 = [
    { bgcolor: "#7FAF6A", completed: 60 },
    { bgcolor: "#e34262", completed: 20 },
    { bgcolor: "#ffb366", completed: 10 },
  ];
  const testData3 = [
    { bgcolor: "#7FAF6A", completed: 50 },
    { bgcolor: "#e34262", completed: 25 },
    { bgcolor: "#ffb366", completed: 25 },
  ];
  // useEffect(() => {
  //   if (
  //     commentsVisibility !== undefined &&
  //     commentsVisibility !== null &&
  //     commentsVisibility !== "" &&
  //     commentsVisibility?.length > 0
  //   ) {
  //     setDiscussionList2(commentsVisibility)
  //     // commentsBox()
  //   }
  // }, [commentsVisibility]);

  // console.log("parentData", parentData);
  useEffect(() => {
    setTimeout(() => {
      postCohortDiscussionActivity({  cohortId:
        parentData?.cohortId != undefined &&
        parentData?.cohortId != null &&
        parentData?.cohortId != ""
          ? parentData?.cohortId
          : urlParams?.cohortId, });
    }, 1000);
  }, []);
  useEffect(() => {
    if (
      cohortActivityData !== undefined &&
      cohortActivityData !== null &&
      cohortActivityData !== ""
    )
      setDiscussionFlag(cohortActivityData);
  }, [cohortActivityData]);
  return (
    <div
    // style={{marginTop:"8rem"}}
    >
      {parentData &&
        parentData !== undefined &&
        parentData !== "" &&
        parentData !== null && (
          <div>
            {/* <div>
              <img
                className="cohortDiscussionBanner"
                src={parentData?.uploadBanner}
              />
            </div> */}

            <div
              className="aboutCohortHeading mt-2"
              style={{ marginTop: "20px", marginBottom: "20px" }}
            >
              {parentData?.program_name}
            </div>

            <div className="purpleBackgroundBox">
              {parentData?.cohort?.cohortStatus !== undefined &&
                parentData?.cohort?.cohortStatus == "CLOSED" && (
                  <div class="d-flex justify-content-end fixedMessageSticky">
                    <div
                      class="fixedMessageStickyText2"
                      style={{ fontSize: "1.25rem" }}
                    >
                      This Cohort is Closed
                    </div>
                  </div>
                )}
              <div className="discussionBox">
                {loggedIn?.role !== "Startup" &&
                  parentData?.cohort?.cohortStatus !== undefined &&
                  parentData?.cohort?.cohortStatus !== "CLOSED" && (
                    <div className="createDiscussionCohort">
                      <div className="boxBorderDiscussion">
                        <div className="d-flex" style={{ padding: "15px" }}>
                          <div>
                            <img
                              // className="cohortMentorProfileIcon"
                              className={
                                parentData?.uploadLogo == null ||
                                parentData?.uploadLogo == "" ||
                                parentData?.uploadLogo == undefined
                                  ? "cohortMentorProfileIconHash"
                                  : "cohortMentorProfileIcon"
                              }
                              src={
                                parentData?.uploadLogo == null ||
                                parentData?.uploadLogo == "" ||
                                parentData?.uploadLogo == undefined
                                  ? profileIcon
                                  : parentData?.uploadLogo
                              }
                              // src={(parentData?.uploadLogo !== undefined && parentData?.uploadLogo !== null && parentData?.uploadLogo !== "") ? parentData?.uploadLogo : profileIcon}
                            />
                          </div>
                          <div className="inputBoxDiscussion">
                            <input
                              onClick={() => {
                                setOpenThread(!openThread);
                                setThreadMode("Create");
                                setThreadIndex(-1);
                              }}
                              className="discussionBoxInput"
                              name="myInput"
                              placeholder="Start a discussion"
                              // disabled
                            />
                          </div>
                        </div>
                      </div>
                      <div className="d-flex cohortDiscussionType">
                        <div className="d-flex">
                          <div>
                            <img src={ArticleIcon} />
                          </div>
                          <div className="cohortDiscussionTypeText">
                            Article
                          </div>
                        </div>
                        <div className="d-flex">
                          <div>
                            <img src={MediaIcon} />
                          </div>
                          <div className="cohortDiscussionTypeText">Media</div>
                        </div>
                        <div
                          className="d-flex"
                          style={{ cursor: "pointer" }}
                          onClick={() => {
                            // setOpenPoll(!openThread);
                            // setPollMode("Create");
                            // setThreadIndex(-1);
                          }}
                        >
                          <div>
                            <img src={PollIcon} />
                          </div>
                          <div className="cohortDiscussionTypeText">Poll</div>
                        </div>
                      </div>
                    </div>
                  )}
                {openThread && threadIndex == -1 && (
                  <CreateThread
                    setModalVisibility={setOpenThread}
                    modalVisibility={openThread}
                    cohortId={parentData.cohortId}
                    parentData={setReloadPage}
                    mode={threadMode}
                    threadData={threadData}
                    setThreadIndex={setThreadIndex}
                  />
                )}
                {openPoll && threadIndex == -1 && (
                  <CreatePoll
                    setModalVisibility={setOpenPoll}
                    modalVisibility={openPoll}
                    cohortId={parentData.cohortId}
                    parentData={setReloadPage}
                    mode={pollMode}
                    // threadData={threadData}
                    setThreadIndex={setThreadIndex}
                  />
                )}
                <div
                  className="cohortDiscussionBody"
                  style={loggedIn?.role == "Startup" ? { marginTop: "0" } : {}}
                >
                  <div className="user-type-dropdown  mt-2 newuserTooltip">
                    <Select
                      required={true}
                      id="Timer"
                      variant="outlined"
                      fullWidth
                      margin="normal"
                      name="Timer"
                      className="col-12 gendermentorinput"
                      styles={customStyles}
                      // value={formData.industry}
                      onChange={(e) => {
                        setThreadSort(e.value);
                        fetchList(listPage, e.value);
                        // setFormData((user) => {
                        //   return {
                        //     ...user,
                        //     industry: e.value == "select" ? null : e,
                        //   };
                        // });
                        // setFilterIndustry(e.value);
                      }}
                      options={approvalOptions}
                      // options={getPredefineOptions?.industry_options}
                      placeholder="Most Recent"
                    />
                    {/* <span
                    className="tooltiptext tooltip-bottom"
                    style={{ left: "77px", top: "45px", width: "130px" }}
                  >
                    Search Industry
                  </span> */}
                  </div>



                  {/* <div
                    className="d-flex"
                    style={{
                      marginTop: "15px",
                      justifyContent: "space-around",
                    }}
                  >
                    <div
                      className="childColumn4"
                      style={{ width: "48%", marginTop: "0" }}
                    >
                      <div
                        className="cohortSessionHeader"
                        style={{
                          backgroundColor: "#b499c7",
                          padding: "0",
                          minHeight: "1rem",
                        }}
                      />
                      <div className="pollsHeading  mt-2">POLLS</div>
                      <div
                        className="cohortDiscussionPostHeader mt-2"
                        style={{ borderTop: "1px solid #dfdfdf" }}
                      >
                        <div className="d-flex " style={{ width: "95%" }}>
                          <div onClick={() => {}}>
                            <img
                              // className="cohortMentorProfileIcon"
                              className="cohortMentorProfileIcon"
                              src="https://maarg-api.startupindia.gov.in/mentorship-app/v1/document/mentorship/mentor/63dcd9ce5a15c73b0905ad49/profile/images(1)1688990608950"
                              // src={profileIcon}
                            />
                          </div>
                          <div className="d-flex cohortDiscussionPostUserBox">
                            <div className="d-flex flex-column">
                              <div className="d-flex">
                                <div
                                  className="d-flex cohortSessionContentItem"
                                  style={{ cursor: "pointer" }}
                                  // onClick={() => {
                                  //   if (item?.postedByRole == "Startup") {
                                  //     viewStartupProfile(item?.postedByDPIITNO);
                                  //   } else {
                                  //     viewMentorProfile(item?.postedBy);
                                  //   }
                                  // }}
                                >
                                  Deepika Rai
                                </div>
                                <div className="cohortDiscussionUserRole">
                                  Mentor
                                </div>
                              </div>
                              <div className="d-flex cohortSessionContentItem3">
                                Technology Lead
                                {" " + "of" + " "}
                                {"  "}VR SoftTech Limited
                              </div>
                            </div>
                          </div>
                        </div>
                        <div>
                          <div className="funtionalCohortIcons">
                            <div>
                              <img
                                // onClick={() => {
                                //   handleDelete(item?.postId);
                                // }}
                                src={DeleteIcon}
                                style={{
                                  maxWidth: "1.25rem",
                                  cursor: "pointer",
                                }}
                              />
                            </div>
                          </div>
                          <div className="cohortDiscussionUserTime">
                            <span>Start Date : 12th Nov 2023</span>
                          </div>
                          <div className="cohortDiscussionUserTime mt-2">
                            <span>End Date : 25th Nov 2023</span>
                          </div>
                        </div>
                      </div>
                      <div style={{ padding: "10px" }}>
                        <div className="cohortSessionTitle2">
                          {" "}
                          Will topics discussed have real world impact ?
                        </div>
                        <div className="cohortSessionContentItem23 mt-2">
                          <div>
                            {true ? (
                              <div className="pollOptions mt-2">
                                {testData2.map((item, idx) => (
                                  <ProgressBar
                                    key={idx}
                                    bgcolor={item.bgcolor}
                                    completed={item.completed}
                                    // completed={completed}
                                    index={idx}
                                    size="low"
                                  />
                                ))}
                              </div>
                            ) : (
                              <div>
                                <div
                                  className="pollOptions mt-2"
                                  // onClick={() => {
                                  //   setProgressView(!progressView);
                                  // }}
                                >
                                  <div className="d-flex">
                                    <input
                                      type="radio"
                                      name="address"
                                      style={{
                                        minHeight: "1.5rem",
                                        marginRight: "10px",
                                      }}
                                      className="radioButtonCohortForm"
                                      onClick={() => {
                                        setPollSelect(1);
                                        setPollErr(false);
                                        // setProgressView(!progressView);
                                      }}
                                      // value={cohortType}
                                      // checked={cohortPublic}
                                      // onChange={()=>{setCohortPublic(true);setCohortPrivate(false);}}
                                    />
                                    <div> Yes </div>
                                  </div>
                                </div>
                                <div
                                  className="pollOptions mt-2"
                                  onClick={() => {
                                    // setProgressView(!progressView);
                                  }}
                                >
                                  <div className="d-flex">
                                    <input
                                      type="radio"
                                      name="address"
                                      style={{
                                        minHeight: "1.5rem",
                                        marginRight: "10px",
                                      }}
                                      className="radioButtonCohortForm"
                                      onClick={() => {
                                        setPollSelect(2);
                                        setPollErr(false);
                                        // setProgressView(!progressView);
                                      }}
                                      // value={cohortType}
                                      // checked={cohortPublic}
                                      // onChange={()=>{setCohortPublic(true);setCohortPrivate(false);}}
                                    />
                                    <div> No </div>
                                  </div>
                                </div>
                                <div
                                  className="pollOptions mt-2"
                                  onClick={() => {
                                    // setProgressView(!progressView);
                                  }}
                                >
                                  <div className="d-flex">
                                    <input
                                      type="radio"
                                      name="address"
                                      style={{
                                        minHeight: "1.5rem",
                                        marginRight: "10px",
                                      }}
                                      className="radioButtonCohortForm"
                                      onClick={() => {
                                        setPollSelect(3);
                                        setPollErr(false);
                                        // setProgressView(!progressView);
                                      }}
                                      // value={cohortType}
                                      // checked={cohortPublic}
                                      // onChange={()=>{setCohortPublic(true);setCohortPrivate(false);}}
                                    />
                                    <div> Sometimes </div>
                                  </div>{" "}
                                </div>
                                {pollErr && (
                                  <div
                                    className="pollOptions mt-2"
                                    style={{
                                      color: "red",
                                      fontFamily: "Montserrat",
                                      fontSize: "14px",
                                    }}
                                  >
                                    Please select at least one answer.
                                  </div>
                                )}
                                <div
                                  className="pollOptions mt-2"
                                  onClick={() => {
                                    // setProgressView(!progressView);
                                  }}
                                  style={{
                                    display: "flex",
                                    alignItems: "center",
                                  }}
                                >
                                  <Button
                                    onClick={() => {
                                      if (pollSelect == 0) setPollErr(true);
                                      else if (pollSelect > 0) {
                                        setPollErr(false);
                                        setProgressView(!progressView);
                                      }
                                    }}
                                    text="VOTE"
                                    className="divButton3 doc-uploadnext"
                                  ></Button>
                                </div>
                              </div>
                            )}
                          </div>
                        </div>
                      </div>
                    </div>
                    <div
                      className="childColumn4"
                      style={{ width: "48%", marginTop: "0" }}
                    >
                      <div
                        className="cohortSessionHeader"
                        style={{
                          backgroundColor: "#b499c7",
                          padding: "0",
                          minHeight: "1rem",
                        }}
                      />
                      <div className="pollsHeading  mt-2">POLLS</div>
                      <div
                        className="cohortDiscussionPostHeader mt-2"
                        style={{ borderTop: "1px solid #dfdfdf" }}
                      >
                        <div className="d-flex " style={{ width: "95%" }}>
                          <div onClick={() => {}}>
                            <img
                              // className="cohortMentorProfileIcon"
                              className="cohortMentorProfileIcon"
                              src="https://preview.keenthemes.com/metronic-v4/theme/assets/pages/media/profile/people19.png"
                              // src="https://maarg-api.startupindia.gov.in/mentorship-app/v1/document/mentorship/mentor/63dcd9ce5a15c73b0905ad49/profile/images(1)1688990608950"
                              // src={profileIcon}
                            />
                          </div>
                          <div className="d-flex cohortDiscussionPostUserBox">
                            <div className="d-flex flex-column">
                              <div className="d-flex">
                                <div
                                  className="d-flex cohortSessionContentItem"
                                  style={{ cursor: "pointer" }}
                                  // onClick={() => {
                                  //   if (item?.postedByRole == "Startup") {
                                  //     viewStartupProfile(item?.postedByDPIITNO);
                                  //   } else {
                                  //     viewMentorProfile(item?.postedBy);
                                  //   }
                                  // }}
                                >
                                  Dev Sharma
                                </div>
                                <div className="cohortDiscussionUserRole">
                                  Mentor
                                </div>
                              </div>
                              <div className="d-flex cohortSessionContentItem3">
                                Director
                                {" " + "of" + " "}
                                Better Health Limited
                              </div>
                            </div>
                          </div>
                        </div>
                        <div>
                          <div className="funtionalCohortIcons">
                            <div>
                              <img
                                // onClick={() => {
                                //   handleDelete(item?.postId);
                                // }}
                                src={DeleteIcon}
                                style={{
                                  maxWidth: "1.25rem",
                                  cursor: "pointer",
                                }}
                              />
                            </div>
                          </div>
                          <div className="cohortDiscussionUserTime">
                            <span>Start Date : 23rd Nov 2023</span>
                          </div>
                          <div className="cohortDiscussionUserTime mt-2">
                            <span>End Date : 26th Nov 2023</span>
                          </div>
                        </div>
                      </div>
                      <div style={{ padding: "10px" }}>
                        <div className="cohortSessionTitle2">
                          {" "}
                          Google VR has the best interface ?
                        </div>
                        <div className="cohortSessionContentItem23 mt-2">
                          <div>
                            {true ? (
                              <div className="pollOptions mt-2">
                                {testData3.map((item, idx) => (
                                  <ProgressBar
                                    key={idx}
                                    bgcolor={item.bgcolor}
                                    completed={item.completed}
                                    // completed={completed}
                                    index={idx}
                                    size="low"
                                  />
                                ))}
                              </div>
                            ) : (
                              <div>
                                <div
                                  className="pollOptions mt-2"
                                  // onClick={() => {
                                  //   setProgressView(!progressView);
                                  // }}
                                >
                                  <div className="d-flex">
                                    <input
                                      type="radio"
                                      name="address"
                                      style={{
                                        minHeight: "1.5rem",
                                        marginRight: "10px",
                                      }}
                                      className="radioButtonCohortForm"
                                      onClick={() => {
                                        setPollSelect(1);
                                        setPollErr(false);
                                        // setProgressView(!progressView);
                                      }}
                                      // value={cohortType}
                                      // checked={cohortPublic}
                                      // onChange={()=>{setCohortPublic(true);setCohortPrivate(false);}}
                                    />
                                    <div> Yes </div>
                                  </div>
                                </div>
                                <div
                                  className="pollOptions mt-2"
                                  onClick={() => {
                                    // setProgressView(!progressView);
                                  }}
                                >
                                  <div className="d-flex">
                                    <input
                                      type="radio"
                                      name="address"
                                      style={{
                                        minHeight: "1.5rem",
                                        marginRight: "10px",
                                      }}
                                      className="radioButtonCohortForm"
                                      onClick={() => {
                                        setPollSelect(2);
                                        setPollErr(false);
                                        // setProgressView(!progressView);
                                      }}
                                      // value={cohortType}
                                      // checked={cohortPublic}
                                      // onChange={()=>{setCohortPublic(true);setCohortPrivate(false);}}
                                    />
                                    <div> No </div>
                                  </div>
                                </div>
                                <div
                                  className="pollOptions mt-2"
                                  onClick={() => {
                                    // setProgressView(!progressView);
                                  }}
                                >
                                  <div className="d-flex">
                                    <input
                                      type="radio"
                                      name="address"
                                      style={{
                                        minHeight: "1.5rem",
                                        marginRight: "10px",
                                      }}
                                      className="radioButtonCohortForm"
                                      onClick={() => {
                                        setPollSelect(3);
                                        setPollErr(false);
                                        // setProgressView(!progressView);
                                      }}
                                      // value={cohortType}
                                      // checked={cohortPublic}
                                      // onChange={()=>{setCohortPublic(true);setCohortPrivate(false);}}
                                    />
                                    <div> Sometimes </div>
                                  </div>{" "}
                                </div>
                                {pollErr && (
                                  <div
                                    className="pollOptions mt-2"
                                    style={{
                                      color: "red",
                                      fontFamily: "Montserrat",
                                      fontSize: "14px",
                                    }}
                                  >
                                    Please select at least one answer.
                                  </div>
                                )}
                                <div
                                  className="pollOptions mt-2"
                                  onClick={() => {
                                    // setProgressView(!progressView);
                                  }}
                                  style={{
                                    display: "flex",
                                    alignItems: "center",
                                  }}
                                >
                                  <Button
                                    onClick={() => {
                                      if (pollSelect == 0) setPollErr(true);
                                      else if (pollSelect > 0) {
                                        setPollErr(false);
                                        setProgressView(!progressView);
                                      }
                                    }}
                                    text="VOTE"
                                    className="divButton3 doc-uploadnext"
                                  ></Button>
                                </div>
                              </div>
                            )}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div> */}



                  {cloneDeep(discussionList2) !== null &&
                    cloneDeep(discussionList2) !== undefined &&
                    cloneDeep(discussionList2) != "" &&
                    cloneDeep(discussionList2)?.length > 0 &&
                    cloneDeep(discussionList2).map((item, index) => {
                      return (
                        <>
                          {openThread && threadIndex == index ? (
                            <>
                              <CreateThread
                                setModalVisibility={setOpenThread}
                                modalVisibility={openThread}
                                cohortId={parentData.cohortId}
                                parentData={setReloadPage}
                                mode={threadMode}
                                threadData={threadData}
                                setThreadIndex={setThreadIndex}
                              />
                            </>
                          ) : (
                            <div className="cohortDiscussionPost">
                              <div className="cohortDiscussionPostHeader">
                                <div
                                  className="d-flex "
                                  style={{ width: "95%" }}
                                >
                                  <div
                                    onClick={() => {
                                      if (item?.postedByRole == "Startup") {
                                        viewStartupProfile(
                                          item?.postedByDPIITNO
                                        );
                                      } else {
                                        viewMentorProfile(item?.postedBy);
                                      }
                                    }}
                                  >
                                    <img
                                      // className="cohortMentorProfileIcon"
                                      className={
                                        item?.postedByImage == null ||
                                        item?.postedByImage == "" ||
                                        item?.postedByImage == undefined
                                          ? "cohortMentorProfileIconHash"
                                          : "cohortMentorProfileIcon"
                                      }
                                      src={
                                        item?.postedByImage == null ||
                                        item?.postedByImage == "" ||
                                        item?.postedByImage == undefined
                                          ? profileIcon
                                          : item?.postedByImage
                                      }
                                    />
                                  </div>
                                  <div className="d-flex cohortDiscussionPostUserBox">
                                    <div className="d-flex flex-column">
                                      <div className="d-flex">
                                        <div
                                          className="d-flex cohortSessionContentItem"
                                          style={{ cursor: "pointer" }}
                                          onClick={() => {
                                            if (
                                              item?.postedByRole == "Startup"
                                            ) {
                                              viewStartupProfile(
                                                item?.postedByDPIITNO
                                              );
                                            } else {
                                              viewMentorProfile(item?.postedBy);
                                            }
                                          }}
                                        >
                                          {item?.postedByName}
                                        </div>
                                        <div className="cohortDiscussionUserRole">
                                          {item?.postedByRole == "Admin"
                                            ? "Maarg Admin"
                                            : item?.postedByRole}
                                        </div>
                                      </div>
                                      {item?.postedByRole !== "Admin" && (
                                        <div className="d-flex cohortSessionContentItem3">
                                          {item?.postedByDesignation}
                                          {" " + "of" + " "}
                                          {item?.postedByOrganization}
                                        </div>
                                      )}
                                    </div>
                                  </div>
                                </div>
                                <div>
                                  <div className="funtionalCohortIcons">
                                    {
                                      // (loggedIn?.id == item?.cohortAdminId ||
                                      loggedIn?.id == item?.postedBy && (
                                        <div>
                                          <img
                                            onClick={() => {
                                              setThreadData(item);
                                              setThreadIndex(index);
                                              setThreadMode("Edit");
                                              setOpenThread(true);
                                            }}
                                            src={EditButton}
                                            style={{
                                              maxWidth: "1.25rem",
                                              cursor: "pointer",
                                            }}
                                          />
                                        </div>
                                      )
                                    }

                                    {(((loggedIn?.id == item?.cohortAdminId ||
                                      loggedIn?.id == item?.postedBy) &&
                                      item?.postedByRole !== "Admin") ||
                                      loggedIn?.role == "Admin") && (
                                      <div>
                                        <img
                                          onClick={() => {
                                            handleDelete(item?.postId);
                                          }}
                                          src={DeleteIcon}
                                          style={{
                                            maxWidth: "1.25rem",
                                            cursor: "pointer",
                                          }}
                                        />
                                      </div>
                                    )}
                                  </div>
                                  <div className="cohortDiscussionUserTime">
                                    {item?.addedDate !== undefined &&
                                      item?.addedDate !== null &&
                                      item?.addedDate !== "" && (
                                        <span>
                                          Created At :{" "}
                                          {timeDifference(item?.addedDate)}
                                        </span>
                                      )}
                                    {/* {tempData.time} */}
                                  </div>
                                  <div className="cohortDiscussionUserTime mt-2">
                                    {item?.addedDate !== undefined &&
                                      item?.addedDate !== null &&
                                      item?.addedDate !== "" && (
                                        <span>
                                          Last Activity :{" "}
                                          {timeDifference(item?.lastUpdated)}
                                        </span>
                                      )}
                                    {/* {tempData.time} */}
                                  </div>
                                </div>
                              </div>
                              <div
                                className="cohortSessionContentItem27 d-flex"
                                style={{ flexDirection: "column" }}
                              >
                                <div className="cohortThreadTitle">
                                  {item?.postTopic}
                                </div>
                                {detectHtml(item?.postMessage) ? (
                                  <>
                                    <div
                                      dangerouslySetInnerHTML={{
                                        __html: item?.postMessage,
                                      }}
                                    />{" "}
                                  </>
                                ) : (
                                  item?.postMessage
                                )}
                              </div>

                              {item?.postAttach !== null &&
                                item?.postAttach !== undefined &&
                                item?.postAttach !== "" &&
                                item?.postAttachType !== null &&
                                item?.postAttachType !== "" &&
                                item?.postAttachType.substring(0, 5) ==
                                  "image" && (
                                  <div>
                                    <img
                                      className="cohortDiscussionImage"
                                      src={item?.postAttach}
                                    />
                                  </div>
                                )}
                              {item?.postAttach !== null &&
                                item?.postAttach !== undefined &&
                                item?.postAttach !== "" &&
                                item?.postAttachType !== null &&
                                item?.postAttachType !== "" &&
                                item?.postAttachType.substring(0, 11) ==
                                  "application" && (
                                  <div className="cohortPdfBox">
                                    <div
                                      className="fileName2"
                                      onClick={() => {
                                        window
                                          .open(item?.postAttach, "_blank")
                                          .focus();
                                      }}
                                    >
                                      View Attachment
                                    </div>
                                  </div>
                                )}
                              {item?.postAttach !== null &&
                                item?.postAttach !== undefined &&
                                item?.postAttach !== "" &&
                                item?.postAttachType !== null &&
                                item?.postAttachType !== "" &&
                                item?.postAttachType == "video/mp4" && (
                                  <div
                                    style={{
                                      display: "flex",
                                      flexDirection: "row",
                                      width: "100%",
                                    }}
                                  >
                                    <div style={{ width: "100%" }}>
                                      <>
                                        {toggleMsg && (
                                          <div className="overlayText">
                                            <p className="topText">
                                              Please wait a few moments, video
                                              is loading ...
                                            </p>
                                          </div>
                                        )}

                                        <div
                                          style={{
                                            display: "flex",
                                            justifyContent: "center",
                                          }}
                                          className="statusiconsmodal newcompletediconsabove"
                                        >
                                          <video
                                            id={"video"}
                                            width="100%"
                                            height="100%"
                                            controls
                                            preload="auto"
                                            autoplay="autoplay"
                                            onLoadedData={() => {
                                              setToggleMsg(false);
                                            }}
                                          >
                                            <source
                                              src={item?.postAttach}
                                              type="video/mp4"
                                            />
                                          </video>
                                        </div>
                                      </>
                                    </div>
                                  </div>
                                )}
                              <div className="cohortDiscussionPostFooter d-flex">
                                <div
                                  className="d-flex"
                                  style={{ width: "15%" }}
                                >
                                  <div
                                    onClick={() => {
                                      if (!item?.liked)
                                        likeTogglePost(item?.postId, true);
                                      else disLikeTogglePost(item?.postId);
                                    }}
                                  >
                                    <img
                                      src={item?.liked ? LikedIcon : LikesIcon}
                                      style={
                                        item?.liked
                                          ? {
                                              width: "fit-content",
                                              maxWidth: "1.75rem",
                                              marginBottom: "1rem",
                                              cursor: "pointer",
                                            }
                                          : { height: "65%", cursor: "pointer" }
                                      }
                                    />
                                  </div>
                                  <div className="cohortDiscussionFooterText">
                                    {item.likes} Likes
                                  </div>
                                </div>
                                {/* <div className="d-flex" style={{ width: "15%" }}>
                              <div
                                onClick={() => {
                                  if (!item?.disliked)
                                    likeTogglePost(item?.postId, false);
                                  else disLikeTogglePost(item?.postId);
                                }}
                              >
                                <img
                                  src={item?.disliked ? LikedIcon : LikesIcon}
                                  style={
                                    item?.disliked
                                      ? {
                                          transform: "scaleY(-1)",
                                          height: "65%",
                                          minWidth: "1.4rem",
                                          maxWidth: "1.5rem",
                                          // position: "relative",
                                          // right: "0.75rem",
                                        }
                                      : {
                                          transform: "scaleY(-1)",
                                          height: "65%",
                                        }
                                  }
                                  // style={
                                  //   item?.liked
                                  //     ? { minWidth: "1.25rem" }
                                  //     : { height: "65%" }
                                  // }
                                />
                              </div>
                              <div className="cohortDiscussionFooterText">
                                {item.dislikes}
                              </div>
                            </div> */}
                                <div
                                  className="d-flex"
                                  style={{ width: "15%" }}
                                >
                                  <div
                                    onClick={() => {
                                      let newArr = cloneDeep(discussionList2);
                                      let boolean =
                                        newArr[index].commentsVisibility;
                                      newArr[index].commentsVisibility =
                                        !boolean;
                                      // setCommentsVisibility(!commentsVisibility);
                                      setDiscussionList2(newArr);
                                    }}
                                  >
                                    <img
                                      src={
                                        item.commentsVisibility
                                          ? CommentIconPressed
                                          : CommentIcon
                                      }
                                      style={{
                                        height: "65%",
                                        minWidth: "2.25rem",
                                        cursor: "pointer",
                                      }}
                                    />
                                  </div>
                                  <div className="cohortDiscussionFooterText">
                                    {item.comments} {"Comments"}
                                  </div>
                                </div>
                              </div>

                              <CommentsBox
                                item={item}
                                postAPI={cohortDiscussionAddComment}
                                modalVisibility={commentsVisibility}
                                discussionList={discussionList2}
                                testIndex={index}
                                viewMentorProfile={viewMentorProfile}
                                viewStartupProfile={viewStartupProfile}
                                getCommentsList={cohortDiscussionCommentsList}
                                reloadPage={setReloadPage}
                                timeDifference={timeDifference}
                                commentLike={cohortCommentPostLikeToggle}
                                commentUnlike={cohortCommentPostRemoveLike}
                              />
                              <div></div>

                              {/* {item?.commentsVisibility && commentsBox(item)} */}
                              {/* {
                            commentsVisibility[index] == true &&
                            
                    } */}
                            </div>
                          )}

                          {discussionList2?.length - 1 == index &&
                            index + 1 !==
                              discussionListPaginate?.totalElements && (
                              <div
                                className="d-flex sessionListMentor"
                                style={{
                                  marginTop: "1rem",
                                  marginLeft: "1rem",
                                  fontWeight: "bold",
                                }}
                                onClick={() => {
                                  setListPage(listPage + 1);
                                  // setCommentsPage(commentsPage + 1);
                                }}
                              >
                                View More Posts
                              </div>
                            )}
                        </>
                      );
                    })}
                </div>
              </div>
              <div className="aboutBox">
                <div>
                  <div
                    className="childColumn"
                    style={{ width: "100%", marginTop: "0" }}
                  >
                    <div
                      className="cohortSessionHeader"
                      style={{
                        backgroundColor: "#b499c7",
                        padding: "0",
                        minHeight: "1rem",
                      }}
                    />
                    <div style={{ padding: "10px" }}>
                      <div className="cohortSessionTitle2">ABOUT</div>
                      <div className="cohortSessionContentItem22 mt-2">
                        {/* Startup India will provide tailored and dedicated
                      mentorship support to the National Startup award winners
                      and finalists. This Cohort program focuses on key Capacity
                      Building on Functional Areas. To ensure the winners and
                      finalists receive this support, Startup India has curated
                      mentorship program focusing on key themes to support their
                      growth trajectory. */}
                        {parentData?.program_desc}
                      </div>
                      <div
                        className="mt-2"
                        style={{ display: "flex", marginLeft: "5px" }}
                      >
                        <div
                          style={{
                            position: "relative",
                            top: "3px",
                            left: "10px",
                          }}
                        >
                          <img src={GlobeIcon} style={{ width: "30px" }} />
                        </div>
                        <div>
                          <div
                            className="cohortSessionTitle2"
                            // style={{ fontWeight: "normal" }}
                          >
                            {parentData?.cohortVisibility
                              ? "Public"
                              : "Private"}
                          </div>
                          <div className="cohortSessionContentItem22">
                            Anyone can join the cohort discussion board,
                            comment, like and post contents.
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div>
                  {/* <div
                    className="childColumn4"
                    style={{ width: "100%", marginTop: "0" }}
                  >
                    <div
                      className="cohortSessionHeader"
                      style={{
                        backgroundColor: "#b499c7",
                        padding: "0",
                        minHeight: "1rem",
                      }}
                    />
                    <div className="pollsHeading  mt-2">POLLS</div>
                   
                    <div style={{ padding: "10px" }}>
                      <div className="cohortSessionTitle2">
                        {" "}
                        Recent market trends shifts to translation of core
                        requirements ?
                      </div>
                      <div className="cohortSessionContentItem23 mt-2">
                        <div>
                          {progressView ? (
                            <div className="pollOptions mt-2">
                              {testData.map((item, idx) => (
                                <ProgressBar
                                  key={idx}
                                  bgcolor={item.bgcolor}
                                  completed={item.completed}
                                  // completed={completed}
                                  index={idx}
                                  size="high"
                                />
                              ))}
                            </div>
                          ) : (
                            <div>
                              <div
                                className="pollOptions mt-2"
                                // onClick={() => {
                                //   setProgressView(!progressView);
                                // }}
                              >
                                <div className="d-flex">
                                  <input
                                    type="radio"
                                    name="address"
                                    style={{
                                      minHeight: "1.5rem",
                                      marginRight: "10px",
                                    }}
                                    className="radioButtonCohortForm"
                                    onClick={() => {
                                      setPollSelect(1);
                                      setPollErr(false);
                                      // setProgressView(!progressView);
                                    }}
                                    // value={cohortType}
                                    // checked={cohortPublic}
                                    // onChange={()=>{setCohortPublic(true);setCohortPrivate(false);}}
                                  />
                                  <div> Yes </div>
                                </div>
                              </div>
                              <div
                                className="pollOptions mt-2"
                                onClick={() => {
                                  // setProgressView(!progressView);
                                }}
                              >
                                <div className="d-flex">
                                  <input
                                    type="radio"
                                    name="address"
                                    style={{
                                      minHeight: "1.5rem",
                                      marginRight: "10px",
                                    }}
                                    className="radioButtonCohortForm"
                                    onClick={() => {
                                      setPollSelect(2);
                                      setPollErr(false);
                                      // setProgressView(!progressView);
                                    }}
                                    // value={cohortType}
                                    // checked={cohortPublic}
                                    // onChange={()=>{setCohortPublic(true);setCohortPrivate(false);}}
                                  />
                                  <div> No </div>
                                </div>
                              </div>
                              <div
                                className="pollOptions mt-2"
                                onClick={() => {
                                  // setProgressView(!progressView);
                                }}
                              >
                                <div className="d-flex">
                                  <input
                                    type="radio"
                                    name="address"
                                    style={{
                                      minHeight: "1.5rem",
                                      marginRight: "10px",
                                    }}
                                    className="radioButtonCohortForm"
                                    onClick={() => {
                                      setPollSelect(3);
                                      setPollErr(false);
                                      // setProgressView(!progressView);
                                    }}
                                    // value={cohortType}
                                    // checked={cohortPublic}
                                    // onChange={()=>{setCohortPublic(true);setCohortPrivate(false);}}
                                  />
                                  <div> Sometimes </div>
                                </div>{" "}
                              </div>
                              {pollErr && (
                                <div
                                  className="pollOptions mt-2"
                                  style={{
                                    color: "red",
                                    fontFamily: "Montserrat",
                                    fontSize: "14px",
                                  }}
                                >
                                  Please select at least one answer.
                                </div>
                              )}
                              <div
                                className="pollOptions mt-2"
                                onClick={() => {
                                  // setProgressView(!progressView);
                                }}
                                style={{
                                  display: "flex",
                                  alignItems: "center",
                                }}
                              >
                                <Button
                                  onClick={() => {
                                    if (pollSelect == 0) setPollErr(true);
                                    else if (pollSelect > 0) {
                                      setPollErr(false);
                                      setProgressView(!progressView);
                                    }
                                  }}
                                  text="VOTE"
                                  className="divButton3 doc-uploadnext"
                                ></Button>
                              </div>
                            </div>
                          )}
                        </div>
                      </div>
                    </div>
                  </div> */}
                </div>
              </div>
            </div>
          </div>
        )}
    </div>
  );
}

const mapStateToProps = (state) => {
  return {
    discussionList: state.MentorReducer.cohortGetDiscussionList.data,
    discussionListPaginate:
      state.MentorReducer.cohortGetDiscussionList.paginate,
    cohortActivityData: state.MentorReducer.cohortDashboardActivity.data,
  };
  // return {
  //   getPredefineOptions: state.AdminMentorReducer.getPredefineOptionsList.list,
  //   detailsGroupSessionData: state.MentorReducer.detailsCohortGroupSession.data,
  // };
};

export default connect(mapStateToProps, {
  cohortDiscussionList,
  cohortCommentPostRemoveLike,
  cohortDiscussionPostRemoveLike,
  cohortDiscussionPostLikeToggle,
  cohortCommentPostLikeToggle,
  cohortDiscussionAddComment,
  cohortDiscussionCommentsList,
  cohortThreadRemovePost,
  postCohortDiscussionActivity,
})(withRouter(DiscussionPage));